import { useAppServices } from 'hook/services'
import { useEffect, useState } from 'react'
import EditModal from '../../EditModal'
import { Icon } from '@mui/material'

export default function DataTableData() {
  const AppService = useAppServices()
  const [loader, setloader] = useState(true)
  const [awardedCompanies, setAwardedCompanies] = useState([]);

  const awardedCompaniesData = async () => {
    setloader(true);
    const { response } = await AppService.app.awarded_companies();
    console.log('responseresponseresponse,response', response)
    if (response.data) {
      setAwardedCompanies(response.data);
    }
    setloader(false);
  };

  const onLoad = () => {
    awardedCompaniesData();
  }

  useEffect(onLoad, [])

  return {
    loader: loader,
    handleRefresh: onLoad,
    dataTableData: {
      columns: [
        { Header: 'Company Name', accessor: 'name' },
        { Header: 'Awards', accessor: 'awards' },
        { Header: 'Address', accessor: 'address' },
        { Header: 'Actions', accessor: 'actions' },
      ],

      rows: awardedCompanies?.map((data) => ({
        name: (
          <div className='flex text-left'>
            <img src={data?.award_config?.company_logo ? data?.award_config?.company_logo : data?.Logo_URL} style={{ height: '50px', width: '50px', marginRight: '5px', objectFit: 'contain' }} />
            {data?.award_config?.company_name ? data?.award_config?.company_name : data?.Name}
          </div>
        ),
        awards: (
          <ul className="mt-2 text-gray-600 dark:text-gray-300 text-left">
            {data?.award_config?.award_claimed?.silver && <li style={{ display: 'flex' }}><Icon style={{ marginRight: '4px' }} fontSize="small">check</Icon>1000 Award ({data?.award_config?.award_claimed?.silver_status ? JSON.parse(data?.award_config?.award_claimed?.silver_status)?.label : 'Requested'})</li>}
            {data?.award_config?.award_claimed?.gold && <li style={{ display: 'flex' }}><Icon style={{ marginRight: '4px' }} fontSize="small">check</Icon>10,000 Award ({data?.award_config?.award_claimed?.gold_status ? JSON.parse(data?.award_config?.award_claimed?.gold_status)?.label : 'Requested'})</li>}
            {data?.award_config?.award_claimed?.platinum && <li style={{ display: 'flex' }}><Icon style={{ marginRight: '4px' }} fontSize="small">check</Icon>100,000 Award ({data?.award_config?.award_claimed?.platinum_status ? JSON.parse(data?.award_config?.award_claimed?.platinum_status)?.label : 'Requested'})</li>}
          </ul>
        ),
        address: (
          <div>
            <span>{data?.award_config?.street}<br /> {data?.award_config?.state_county}<br /> {data?.award_config?.city}<br /> {data?.award_config?.zip_code}<br /> {data?.award_config?.country}</span>
            <br />
            Old Address formate: <strong>{data?.award_config?.award_address}</strong>
          </div>
        ),
        actions: (
          <EditModal data={data} handleRefresh={onLoad} />
        ),
      })),
    },
  }
}
